<template>
  <div id="givingmonthly">
    <Background />
    <h1>Giving</h1>
    <div class="ml-24 mr-24 mt-4">
      <p>Support given here goes to help Sojourn fulfill its mission of glorifying God through making disciples by evangelizing the lost and equipping the saints. </p>
      <p>Setup one-time or monthly automatic deductions on this page.</p>
      <div class="m-4">
        <p>Need help? Contact <b>{{ourEmail}}</b> </p>
      </div>
    </div>
    <form @submit.prevent="submitCard">
      <div id="form" class="flex-col">
        <ProductSelect class="m-4"
          v-bind:defaultIsMonthly="false"
          v-on:is-monthly="setData('isMonthly', $event)"
          v-on:plan-selected-id="setData('planSelectedId', $event)"
          v-on:price-selected-id="setData('priceSelectedId', $event)" />
        <div class="m-2">
          <label>Donation</label>
          <div class="flex-col">
            <div class="m-1">
              <span class="currency">$</span>
              <input id="planAmount" name="planAmount" type="text"
                class="input-text w-16"
                placeholder="0.00" v-model="planAmount" />
            </div>
          </div>
        </div>
        <div class="group">
          <label></label>
          <div id="card-errors" role="alert" class="has-text-danger">{{error}}</div>
        </div>
        <div class="group">
          <label></label>
          <div id="card-success" role="note" class="has-text-success">{{success}}</div>
        </div>
        <div class="button-right m-4">
          <button class="btn-pill"
            v-bind:class="{ 'gray-pill': submitting, 'orange-pill': !submitting }"
            :disabled="submitting">{{submitCaption}}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped>

.input-text {
  @apply text-black;
}

</style>

<script>

import client from '../client/client'
import loader from '../client/loader'

import Background from './Background.vue'
import ProductSelect from './ProductSelect.vue'

export default {
  name: 'GivingMonthly',
  data () {
    return {
      ourEmail: 'SojournEnid' + String.fromCharCode(0x40) + 'gmail' + '.com',
      submitting: false,
      error: null,
      success: null,
      pubApiKey: null,
      stripeClient: null,

      planAmount: null,
      isMonthly: false,

      priceSelectedId: null,
      planSelectedId: null
    }
  },
  computed: {
    submitCaption: function () {
      return this.submitting ? 'Submitting...' : 'Send Donation'
    },
    planAmountAsPennies: function() {
      let myThis = this
      return parseInt(myThis.planAmount * 100)
    },
    planQuantity: function () {
      let myThis = this
      let by10 = myThis.planAmount % 10
      if (by10 === 0) {
        return myThis.planAmount / 10
      } else {
        return 0
      }
    }
  },
  components: {
    Background,
    ProductSelect
  },
  methods: {
    clear () {
      let myThis = this

      myThis.displayError(null)
      myThis.displaySuccess(null)

      myThis.submitting = true
    },
    submitCard () {
      let DOMAIN = window.location.href
      let myThis = this

      myThis.clear()
      if (!myThis.preSubmitValidate()) {
        myThis.submitting = false
        return
      }

      let item = {
        quantity: myThis.planQuantity
      }
      let mode = undefined
      if(myThis.isMonthly) {
        item.price = myThis.planSelectedId
        mode = 'subscription'
      } else {
        item.price = myThis.priceSelectedId
        mode = 'payment'
      }

      myThis.stripeClient.redirectToCheckout({
          lineItems: [ item ],
          mode: mode,
          successUrl:
            DOMAIN + "thankyou",
          cancelUrl: DOMAIN + "cancelled"
        })
        .then(myThis.checkResult)
    },
    checkResult (result) {
      if (result.error) { throw result.error }
    },
    preSubmitValidate () {

      if (!this.validateAmount()) {
        this.displayError(new Error(`Please choose ${ this.isMonthly ? 'a monthly' : 'an' } amount in increments of $10.00.`))
        return false
      } else if(this.isMonthly && (this.planSelectedId || '').length === 0) {
        this.displayError(new Error('Choose a monthly donation budget.'))
        return false
      } else if(!this.isMonthly && (this.priceSelectedId || '').length === 0) {
        this.displayError(new Error('Choose a donation budget.'))
        return false
      } else if(
        ((this.priceSelectedId || '').indexOf('configNeeded') > -1) || 
        ((this.planSelectedId || '').indexOf('configNeeded') > -1)
      ) {
        this.displayError(new Error('There seems to be a configuration error related to the selected donation budget. Please contact Sojourn.'))
        return false
      }

      return true
    },
    validateAmount () {
      let myThis = this
      return myThis.planQuantity > 0
    },
    displayError (error) {
      let errorElement = document.getElementById('card-errors')
      if (error && errorElement) {
        errorElement.textContent = error.message
      } else {
        if(errorElement) {
          errorElement.textContent = ''
        }
      }
    },
    displaySuccess (msg) {
      let successElement = document.getElementById('card-success')
      if (msg) {
        successElement.textContent = msg
      } else {
        successElement.textContent = ''
      }
    },
    setData(propName, eventValue) {
      this[propName] = eventValue
    }
  },
  created () {
    loader.js.injectStripeDependency(document)
  },
  mounted () {
    let myThis = this
    loader.js.awaitStripe()
      .then(() => {
        myThis.pubApiKey = client.pubApiKey
        // eslint-disable-next-line
        myThis.stripeClient = Stripe(myThis.pubApiKey)
      })
      .catch(() => {
        myThis.displayError('Payment processing is unavailable at this time. Please try again later (Stripe.js loader).', myThis)
      })
  }
}

</script>
